import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'
 
import VForm17CollectionToggle from './VForm17CollectionToggle.vue' 

declareVconsoleComponent('vForm17CollectionToggle', VForm17CollectionToggle)